import { render, staticRenderFns } from "./advertising_list.vue?vue&type=template&id=2c4b6b54&scoped=true&"
import script from "./advertising_list.vue?vue&type=script&lang=js&"
export * from "./advertising_list.vue?vue&type=script&lang=js&"
import style0 from "./advertising_list.vue?vue&type=style&index=0&id=2c4b6b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b6b54",
  null
  
)

export default component.exports